import React, { FC, Fragment } from "react";
import classNames from "classnames";
import { Link } from "@app/components/common";

type Props = {
  slug: string;
  category: string;
};

export const Breadcrumbs: FC<Props> = ({ slug, category }) => {
  const articleName = slug.replace(/[-_]/g, " ");
  const articleCategoryName = category.replace(/[-_]/g, " ");

  const navSections = [
    {
      name: "Blog",
      path: "/blog/",
    },
    {
      name: articleCategoryName,
      path: `/blog/${category}/#articlesList`,
    },
    {
      name: articleName,
      path: `/blog/${category}/${slug}`,
    },
  ];
  const lastNavSectionIndex = navSections.length - 1;

  return (
    <nav
      aria-label="breadcrumb"
      className={classNames("text-regular text-base-400")}
    >
      <ol className={classNames("flex w-full items-center gap-x-4")}>
        {navSections?.map((navSection, index) => (
          <Fragment key={index}>
            {index ? (
              <li className="bg-primary-content block h-0.75 w-0.75 rounded-full" />
            ) : null}
            <li
              className={classNames("block first-letter:uppercase", {
                "text-primary-content xxl:max-w-96 truncate overflow-hidden text-ellipsis whitespace-nowrap":
                  index === lastNavSectionIndex,
              })}
            >
              <Link
                to={navSection.path}
                className="hover:text-primary-content no-underline duration-300"
              >
                {navSection.name}
              </Link>
            </li>
          </Fragment>
        ))}
      </ol>
    </nav>
  );
};
